<!-- <div *ngIf="!frontpaginate" class="row" style="width: 500px">
  <div class="col-md-6">
    <div *ngIf="cleanbulk">
      <button
        [disabled]="!bulk.length"
        class="btn btn-link btn-default btn-just-icon"
        title="Clean Selected"
        (click)="cleanBulk()"
      >
        <i class="material-icons">cleaning_services</i>
      </button>
      Selected items: {{ bulk.length }}
    </div>
  </div>
  <div
    class="form-group col-md-6"
    style="float: right; display: inline-flex; position: relative"
  >
    <form style="display: flex; position: absolute; right: 0px; top: -24px">
      <div
        style="cursor: pointer; max-width: 100px; width: -webkit-fill-available"
        *ngIf="esbusqueda"
        (click)="restoreTable()"
        class="text-danger"
      >
        <span class="material-icons">restore</span> Reset Table
      </div>
      <input
        style="margin-left: 10px; padding: 22px"
        type="text"
        placeholder="Search"
        class="form-control"
        id="campoBusquedaForm"
        [ngModelOptions]="{ standalone: true }"
        #campoBusquedaForm="ngModel"
        [(ngModel)]="campoBusqueda"
      />
      <button
        style="margin-left: 10px"
        (click)="search()"
        class="btn btn-small btn-info"
      >
        Search
      </button>
    </form>
  </div>
</div> -->

<div class="d-flex justify-content-between">
  <div class="">
    <div *ngIf="cleanbulk">
      <button
        [disabled]="!bulk.length"
        class="btn btn-link btn-default btn-just-icon"
        title="Clean Selected"
        (click)="cleanBulk()"
      >
        <i class="material-icons">cleaning_services</i>
      </button>
      Selected items: {{ bulk.length }}
    </div>
  </div>
  <div class="">
    <div
      *ngIf="!frontpaginate && search"
    >
      <div
        class="form-group"
        style="display: inline-flex; position: relative"
      >
        <form class="d-flex">
          <div
        style="cursor: pointer; max-width: 100px; width: -webkit-fill-available"
        *ngIf="esbusqueda"
        (click)="restoreTable()"
        class="text-danger"
      >
        <span class="material-icons">restore</span> Reset Table
      </div>
      <input
        style="margin-left: 10px; padding: 22px"
        type="text"
        placeholder="Search"
        class="form-control"
        id="campoBusquedaForm"
        [ngModelOptions]="{ standalone: true }"
        #campoBusquedaForm="ngModel"
        [(ngModel)]="campoBusqueda"
      />
      <button
        style="margin-left: 10px"
        (click)="search()"
        class="btn btn-small btn-info"
      >
        Search
      </button>
        </form>
      </div>
    </div>
  </div>
</div>

<br *ngIf="!frontpaginate" /><br *ngIf="!frontpaginate" />

<greeting
  type="{{ ref }}"
  [data]="data"
  [order]="r.order"
  [orderby]="r.orderby"
  [table_id]="id"
  [bulk]="bulk"
  (newOptions)="setOptions($event)"
  (changeBulk)="setBulk($event)"
  (sortby)="sort($event)"
  (out)="send($event)"
></greeting>

<div *ngIf="!frontpaginate" class="clearfix"></div>
<nav *ngIf="!frontpaginate" aria-label="...">
  <div
    style="
      display: flex;
      flex-direction: column;
      width: 100%;
      position: relative;
    "
  >
    <mat-form-field style="max-width: 90px">
      <mat-select
        (selectionChange)="changeLimit()"
        placeholder="Showing"
        name="showing"
        [(ngModel)]="items_per_page"
        ariaLabel="itemsPerPageSelected"
      >
        <mat-option value="5">5</mat-option>
        <mat-option value="10">10</mat-option>
        <mat-option value="25">25</mat-option>
        <mat-option value="50">50</mat-option>
        <mat-option value="100">100</mat-option>
        <mat-option value="200">200</mat-option>
        <mat-option value="500">500</mat-option>
        <mat-option value="1000">1000</mat-option>
        <mat-option value="ALL">ALL</mat-option>
      </mat-select>
    </mat-form-field>
    <p style="align-self: center">
      Showing {{ this.showingNav }} to {{ this.showingTo }} of
      {{ total_items_count }} entries
    </p>

    <ul class="pagination align-self-center">
      <div style="display: flex">
        <li class="page-item">
          <a
            (click)="goToPage(1)"
            *ngIf="page_actual > 1"
            class="page-link"
            tabindex="-1"
            >First</a
          >
        </li>
        <li class="page-item">
          <a
            (click)="goToPage(page_actual - 1)"
            *ngIf="page_actual > 1"
            class="page-link"
            tabindex="-1"
            >Previous</a
          >
        </li>
        <li *ngFor="let page of pages" class="page-item">
          <a
            [className]="
              page_actual == page + 1 ? 'selected-page' : 'page-link'
            "
            (click)="goToPage(page + 1)"
            >{{ page + 1 }}</a
          >
        </li>
        <li class="page-item">
          <a
            class="page-link"
            *ngIf="page_actual < total_pages"
            (click)="goToPage(page_actual + 1)"
            >Next</a
          >
        </li>
        <li class="page-item">
          <a
            (click)="goToPage(total_pages)"
            *ngIf="page_actual < total_pages"
            class="page-link"
            tabindex="-1"
            >Last</a
          >
        </li>
      </div>
    </ul>
  </div>
</nav>
